import React, { useEffect, useState } from 'react';
import { Mic, Loader2 } from 'lucide-react';
import apiService from '../../services/apiService';

const UNAVAILABLE_TEXT =
  'Ses kaydı mevcut değil. Yalnızca son 3 görüşmenin kaydı sunucuda tutulur.';

const CallRecordingPlayer = ({ callId, hasRecording }) => {
  const [audioUrl, setAudioUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [unavailable, setUnavailable] = useState(!hasRecording);

  useEffect(() => {
    if (!callId || !hasRecording) {
      setAudioUrl(null);
      setUnavailable(true);
      setLoading(false);
      return undefined;
    }

    let objectUrl;
    let cancelled = false;

    const loadRecording = async () => {
      setLoading(true);
      setUnavailable(false);
      setAudioUrl(null);
      try {
        const blob = await apiService.fetchCallRecording(callId);
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setAudioUrl(objectUrl);
      } catch {
        if (!cancelled) {
          setUnavailable(true);
          setAudioUrl(null);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadRecording();

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [callId, hasRecording]);

  return (
    <div>
      <p className="mb-2 flex items-center gap-1.5 text-[11px] uppercase tracking-wider text-slate-500">
        <Mic className="h-3.5 w-3.5" />
        Görüşme kaydı
      </p>

      {loading && (
        <div className="flex items-center gap-2 rounded-lg bg-white/5 p-3 text-sm text-slate-400 ring-1 ring-white/10">
          <Loader2 className="h-4 w-4 animate-spin" />
          Ses kaydı yükleniyor…
        </div>
      )}

      {!loading && unavailable && (
        <p className="rounded-lg bg-white/[0.03] p-3 text-sm text-slate-400 ring-1 ring-white/10">
          {UNAVAILABLE_TEXT}
        </p>
      )}

      {!loading && !unavailable && audioUrl && (
        <audio
          controls
          preload="metadata"
          src={audioUrl}
          className="w-full rounded-lg bg-white/5 p-2 ring-1 ring-white/10"
        >
          Tarayıcınız ses oynatmayı desteklemiyor.
        </audio>
      )}
    </div>
  );
};

export default CallRecordingPlayer;
